import React from "react";

const PurpleGradient = () => {
  return (
    <div className="fixed inset-0 pointer-events-none">
      <div className="absolute inset-0 bg-gradient-to-br from-black via-purple-950/30 to-black" />
      <div
        className="absolute top-10 left-1/4 w-96 h-96 bg-purple-600/20 rounded-full blur-3xl opacity-30 animate-pulse"
        style={{ animationDuration: "8s" }}
      />
      <div
        className="absolute -top-20 right-1/4 w-80 h-80 bg-indigo-600/15 rounded-full blur-3xl opacity-25 animate-pulse"
        style={{ animationDuration: "10s", animationDelay: "2s" }}
      />
      <div
        className="absolute -bottom-32 left-1/3 w-96 h-96 bg-cyan-600/10 rounded-full blur-3xl opacity-20 animate-pulse"
        style={{ animationDuration: "12s", animationDelay: "4s" }}
      />
      <div
        className="absolute bottom-0 -right-48 w-96 h-96 bg-pink-600/15 rounded-full blur-3xl opacity-20 animate-pulse"
        style={{ animationDuration: "9s", animationDelay: "1s" }}
      />
      <svg
        className="absolute inset-0 w-full h-full opacity-10"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <pattern
            id="grid"
            width="40"
            height="40"
            patternUnits="userSpaceOnUse"
          >
            <path
              d="M 40 0 L 0 0 0 40"
              fill="none"
              stroke="#7c3aed"
              strokeWidth="0.5"
            />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#grid)" />
      </svg>

      <div className="absolute top-0 left-0 w-full h-full opacity-30">
        <div className="absolute top-1/3 left-0 w-1/2 h-px bg-gradient-to-r from-purple-600/30 to-transparent" />
        <div className="absolute top-2/3 right-0 w-1/2 h-px bg-gradient-to-l from-indigo-600/30 to-transparent" />
      </div>
    </div>
  );
};

export default PurpleGradient;
